import {
  apiCallWithAntiForgery,
  keepzApiCallWithAntiForgery,
  // setAntiforgery
} from "./common";
import {
  getAgreements,
  getAuthLink,
  getPeps,
  getCities,
  getCountries,
  submitForm,
  sendSmsTanCode,
} from "./common/sharedServices";

export async function GEtAgreementHTML(payload) {
  return apiCallWithAntiForgery("post", `form/GetAgreementHtml`, payload);
}

export async function GEtAgreementHTMLForRSandCI(payload) {
  return apiCallWithAntiForgery("post", `form/GetAgreementRsAndCI`, payload);
}

export async function getAgreementsForLoanApplication({
  OrganizationName = null,
  TaxCode = null,
} = {}) {
  return keepzApiCallWithAntiForgery(
    "post",
    `form/GetLoanApplicationAgreements`,
    { OrganizationName, TaxCode }
  );
}

export async function submitLoanApplication(payload) {
  return keepzApiCallWithAntiForgery("post", "Form/SubmitLoanApplication", payload);
}

const creditInfoServices = {
  getAgreements,
  getAuthLink,
  getPeps,
  getCities,
  getCountries,
  GEtAgreementHTML,
  submitForm,
  sendSmsTanCode,
  GEtAgreementHTMLForRSandCI,
  getAgreementsForLoanApplication,
};

export default creditInfoServices;
